import React, { useRef, useEffect } from 'react';
import './Team.css';
import angelImage from '../assets/images/Teamheadshots/angel.jpg';
import kadenImage from '../assets/images/Teamheadshots/kaden.jpg';
import cherylImage from '../assets/images/logo512.png';
import evelynImage from '../assets/images/Teamheadshots/evelyn.jpg';
import akankshaImage from '../assets/images/Teamheadshots/akansha.jpg';
import jessieImage from '../assets/images/Teamheadshots/jessie.jpeg';
import meganImage from '../assets/images/Teamheadshots/megan.jpg';
import kristenImage from '../assets/images/Teamheadshots/kristen.jpg';
import kyleImage from '../assets/images/Teamheadshots/kyle.jpeg';

const Team = () => {
    const titleRef = useRef(null);
    
    useEffect(() => {
        titleRef.current.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        });
    }, []);

    const teamMembers = [
        { name: "Angel Hon", position: "Head Coordinator", school: "St. Paul's Convent School", image: angelImage },
        { name: "Kaden Hui", position: "Head Coordinator", school: "West Island School", image: kadenImage},
        { name: "Cheryl Leung", position: "Director of Conference", school: "Renaissance College", image: cherylImage },
        { name: "Evelyn Chan", position: "Deputy Director of Conference", school: "Po Leung Kuk Choi Kai Yau School", image: evelynImage },
        { name: "Akanksha Sharma", position: "Director of Contest", school: "Sha Tin College", image: akankshaImage},
        { name: "Jessie Yim", position: "Deputy Director of Contest", school: "Canadian International School", image:jessieImage},
        { name: "Megan Wong", position: "Deputy Director of Contest", school: "Renaissance College", image: meganImage },
        { name: "Kristen Wu", position: "Director of Publicity", school: "Island School", image:kristenImage},
        { name: "Kyle Hui", position: "Deputy Director of Publicity", school: "St. Paul's Co Educational College", image: kyleImage }
    ];

    // Past Executive Board data grouped by year
    const pastBoards = [
        {
            year: "2025-26",
            members: [
                { name: "Yvonne Chan", position: "Head Coordinator", school: "St. Paul's Co-educational College" },
                { name: "Charmaine Wong", position: "Head Coordinator", school: "Island School" },
                { name: "Jamie Yu", position: "Director of the 7th Clean Air Conference", school: "Island School" },
                { name: "Angel Hon", position: "Deputy Director of the 7th Clean Air Conference", school: "St. Paul's Convent School" },
                { name: "Kelly Au", position: "Director of the 3rd HK Clean Air Public Speaking Contest", school: "St. Paul's Co-educational College" },
                { name: "Jessie Yim", position: "Deputy Director of the 3rd HK Clean Air Public Speaking Contest", school: "Canadian International School" },
                { name: "Layla Wong", position: "Director of Publicity (Content)", school: "St. Paul's Co-educational College" },
                { name: "Isabella Chan", position: "Director of Publicity (Multimedia)", school: "American International School" },
            ]
        },
        {
            year: "2024-25",
            members: [
                { name: "Yvonne Chan", position: "Head Coordinator", school: "St. Paul's Co-educational College" },
                { name: "Ava Au Yeung", position: "Head Coordinator", school: "Island School | UPenn" },
                { name: "Audrey Ho", position: "Director of the 6th Clean Air Conference", school: "St. Paul's Co-educational College" },
                { name: "Gurnoor Sahota", position: "Director of the 6th Clean Air Conference", school: "Delia Memorial School (Glee Path)" },
                { name: "Archi Jain", position: "Director of the 2nd HK Clean Air Public Speaking Contest", school: "HKMA David Li Kwok Po College" },
                { name: "Megan Chan", position: "Director of the 2nd HK Clean Air Public Speaking Contest", school: "Island School" },
                { name: "Kaden Hui", position: "Director of Publicity", school: "West Island School" }
            ]
        },
        {
            year: "2023-24",
            members: [
                { name: "Alexandra Lai", position: "Head Coordinator", school: "Island School | UC Berkeley" },
                { name: "Yvonne Chan", position: "Head Coordinator", school: "St. Paul's Co-educational College" },
                { name: "Ava Au Yeung", position: "Director of Events", school: "Island School" },
                { name: "Peter Yoon", position: "Director of Events", school: "Island School" },
                { name: "Gloria Mak", position: "Director of the 1st HK Clean Air Public Speaking Contest", school: "St. Paul's Co-educational College" },
                { name: "Megan Chan", position: "Director of Publicity", school: "Island School" }
            ]
        },
        {
            year: "2022-23",
            members: [
                { name: "Zoe Yu", position: "Head Coordinator", school: "St. Paul's Co-educational College | Phillips Academy Andover | Brown" },
                { name: "Hannah Wu", position: "Head Coordinator", school: "Island School | UToronto" },
                { name: "Alexandra Lai", position: "Director of Events", school: "Island School" },
                { name: "Ava Chong", position: "Director of Events", school: "St. Paul's Co-educational College" },
                { name: "Gloria Mak", position: "Director of Editorial", school: "St. Paul's Co-educational College" },
                { name: "Yvonne Chan", position: "Editor in Chief", school: "St. Paul's Co-educational College" },
                { name: "Joanne Helly", position: "Director of Design", school: "Australian International School" },
                { name: "Aavni Ahuja", position: "Director of Outreach", school: "Chinese International School" }
            ]
        }
    ];

    return (
        <div className="team-page" ref={titleRef}>
            <section className="team-hero">
                <h1> Executive Board</h1>
                <p className="team-subtitle">Meet the Student Leaders Driving Our Clean Air Mission Forward</p>
            </section>

            <div className="team-grid-container">
                <div className="team-grid-row">
                    {teamMembers.slice(0, 3).map((member, index) => (
                        <div className="team-member" key={index}>
                            <div className="member-image-container">
                                <img src={member.image} alt={member.name} className="member-image" />
                            </div>
                            <h3 className="member-name">{member.name}</h3>
                            <p className="member-position">{member.position}</p>
                            <p className="member-school">{member.school}</p>
                        </div>
                    ))}
                </div>
                <div className="team-grid-row">
                    {teamMembers.slice(3).map((member, index) => (
                        <div className="team-member" key={index + 3}>
                            <div className="member-image-container">
                                <img src={member.image} alt={member.name} className="member-image" />
                            </div>
                            <h3 className="member-name">{member.name}</h3>
                            <p className="member-position">{member.position}</p>
                            <p className="member-school">{member.school}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Past Executive Board Section */}
            <section className="past-board-section">
                <h2 className="past-board-heading">Past Executive Boards</h2>
                {pastBoards.map((board, index) => (
                    <div className="past-board-year" key={index}>
                        <h3 className="past-board-year-title">{board.year}</h3>
                        <ul className="past-board-list">
                            {board.members.map((member, idx) => (
                                <li className="past-board-member" key={idx}>
                                    {member.name} ({member.position}), {member.school}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default Team;
